import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-9567bd30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block-wrapper" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "search-wrapper" }
const _hoisted_5 = { class: "search-row" }
const _hoisted_6 = { class: "search-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Entity ", -1))
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " BU ", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Submission Date ", -1))
const _hoisted_12 = { class: "search-btn" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_15 = { class: "control-wrapper" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Download SICCO Checking Plan ")
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "content-item" }
const _hoisted_19 = { class: "content-block flex-wrapper" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "To Dealer")
], -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "content-item" }
const _hoisted_23 = { class: "content-block" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "To MBAFC/MBLC")
], -1))
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_all_entity_selector = _resolveComponent("all-entity-selector")!
  const _component_bu_selector = _resolveComponent("bu-selector")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_tab_table = _resolveComponent("tab-table")!
  const _component_set_modal = _resolveComponent("set-modal")!
  const _component_download_modal = _resolveComponent("download-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_all_entity_selector, {
                  ref: "entityRef",
                  value: _ctx.entity,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity) = $event)),
                  allowClear: true,
                  "is-all": false,
                  mode: "multiple",
                  placeholder: "Please select",
                  class: "select",
                  maxTagCount: 2
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_bu_selector, {
                  ref: "buRef",
                  placeholder: "Please select",
                  class: "select",
                  value: _ctx.bu,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bu) = $event)),
                  allowClear: "",
                  mode: "multiple",
                  maxTagCount: 2,
                  isCurrent: true
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_a_range_picker, {
                  value: _ctx.submissionDate,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.submissionDate) = $event)),
                  "value-format": "YYYY-MM-DD",
                  allowClear: false
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_button, {
                  onClick: _ctx.reset,
                  style: {"margin-right":"15px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_a_button, { onClick: _ctx.handleDownload }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_tab_table, {
              onOnBatchSet: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleBatchSet('Dealer'))),
              onOnSet: _cache[4] || (_cache[4] = (id, row) => _ctx.handleSet(id, row, 'Dealer')),
              onOnSelectChange: _cache[5] || (_cache[5] = 
                            (keys, rows) => _ctx.handleTableSelectChange(keys, rows, 'Dealer')
                        ),
              class: "flex-height flex-wrapper",
              entity: _ctx.entityList,
              column: _ctx.dealerColumn,
              data: _ctx.dealerList
            }, {
              link: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: "link",
                  onClick: ($event: any) => (_ctx.handleLinkClick(row, 'Dealer'))
                }, _toDisplayString(row.packageCode), 9, _hoisted_21)
              ]),
              _: 1
            }, 8, ["entity", "column", "data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_tab_table, {
              onOnBatchSet: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleBatchSet('Fl'))),
              onOnSet: _cache[7] || (_cache[7] = (id, row) => _ctx.handleSet(id, row, 'Fl')),
              onOnSelectChange: _cache[8] || (_cache[8] = 
                            (keys, rows) => _ctx.handleTableSelectChange(keys, rows, 'Fl')
                        ),
              class: "flex-height flex-wrapper",
              entity: _ctx.entityList,
              column: _ctx.flColumn,
              data: _ctx.flList
            }, {
              link: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: "link",
                  onClick: ($event: any) => (_ctx.handleLinkClick(row, 'Fl'))
                }, _toDisplayString(row.payoutCode), 9, _hoisted_25)
              ]),
              _: 1
            }, 8, ["entity", "column", "data"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_set_modal, {
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalVisible) = $event)),
      user: _ctx.userList,
      dealerIds: _ctx.dealerKeys,
      packageCodes: _ctx.packageCodes,
      flIds: _ctx.flKeys,
      onOnSetChange: _ctx.handleSetChange
    }, null, 8, ["visible", "user", "dealerIds", "packageCodes", "flIds", "onOnSetChange"]),
    _createVNode(_component_download_modal, {
      visible: _ctx.downloadModalVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.downloadModalVisible) = $event))
    }, null, 8, ["visible"])
  ], 64))
}